module.exports = __webpack_public_path__ + "static/img/home_img_02@3x.fc21285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-page/home_img_02@3x.jpg
// module id = 85
// module chunks = 49